import type { BeforeRequestHook } from "ky";

export const generateRequestId: BeforeRequestHook = async ({ request }) => {
  const requestId = generateRandomId();
  request.headers.set("X-Request-ID", requestId);
};

function generateRandomId() {
  // Prefer using crypto.randomUUID
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  // Fallback to manual UUID generation
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
